export const PRIZE_WHEEL_CONFIG = [
  { label: "TRY AGAIN", weight: 15 },
  { label: "$10 GIFT CARD", weight: 2.5 },
  { label: "TRY AGAIN", weight: 15 },
  { label: "$10 GIFT CARD", weight: 2.5 },
  { label: "TRY AGAIN", weight: 15 },
  { label: "$20 GIFT CARD", weight: 1 },
  { label: "TRY AGAIN", weight: 15 },
  { label: "$10 GIFT CARD", weight: 2.5 },
  { label: "TRY AGAIN", weight: 15 },
  { label: "$5 GIFT CARD", weight: 3 },
  { label: "TRY AGAIN", weight: 13 },
  { label: "$10 GIFT CARD", weight: 2.5 }
]

export const PRIZE_WHEEL_COLORS = [
  '#ffc93c', '#66bfbf', '#a2d5f2', '#515070',
  '#43658b', '#ed6663', '#d54062'
]